import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { request, METHOD } from '@/utils/request';

/**
 * 查询数据源分页 
 */
export function queryDataSourcePage(_x, _x2, _x3) {
  return _queryDataSourcePage.apply(this, arguments);
}
/**
 * 数据源保存
 */
function _queryDataSourcePage() {
  _queryDataSourcePage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(page, limit, param) {
    var data;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          // 数据处理
          data = {
            currentNo: page,
            pageSize: limit,
            sjymc: param.sjymc,
            xsmc: param.xsmc,
            sjklx: param.sjklx
          };
          return _context.a(2, request("/formManage/queryDataSourcePage", METHOD.POST, data));
      }
    }, _callee);
  }));
  return _queryDataSourcePage.apply(this, arguments);
}
export function dataSourceSave(_x4) {
  return _dataSourceSave.apply(this, arguments);
}
/**
 * 数据源修改
 */
function _dataSourceSave() {
  _dataSourceSave = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(data) {
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          return _context2.a(2, request("/formManage/dataSourceSave", METHOD.POST, data));
      }
    }, _callee2);
  }));
  return _dataSourceSave.apply(this, arguments);
}
export function dataSourceEdit(_x5) {
  return _dataSourceEdit.apply(this, arguments);
}
/**
 * 数据源测试
 */
function _dataSourceEdit() {
  _dataSourceEdit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(data) {
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          return _context3.a(2, request("/formManage/dataSourceEdit", METHOD.POST, data));
      }
    }, _callee3);
  }));
  return _dataSourceEdit.apply(this, arguments);
}
export function dataSourceTest(_x6) {
  return _dataSourceTest.apply(this, arguments);
}
/**
 * 数据源删除
 */
function _dataSourceTest() {
  _dataSourceTest = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(data) {
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          return _context4.a(2, request("/formManage/dataSourceTest", METHOD.POST, data));
      }
    }, _callee4);
  }));
  return _dataSourceTest.apply(this, arguments);
}
export function dataSourceDelete(_x7) {
  return _dataSourceDelete.apply(this, arguments);
}
/**
 * 数据源启用/停用
 */
function _dataSourceDelete() {
  _dataSourceDelete = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(data) {
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          return _context5.a(2, request("/formManage/dataSourceDelete", METHOD.POST, data));
      }
    }, _callee5);
  }));
  return _dataSourceDelete.apply(this, arguments);
}
export function dataSourceEnable(_x8) {
  return _dataSourceEnable.apply(this, arguments);
}
/**
 * 数据源详情
 */
function _dataSourceEnable() {
  _dataSourceEnable = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(data) {
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.n) {
        case 0:
          return _context6.a(2, request("/formManage/dataSourceEnable", METHOD.POST, data));
      }
    }, _callee6);
  }));
  return _dataSourceEnable.apply(this, arguments);
}
export function dataSourceDetail(_x9) {
  return _dataSourceDetail.apply(this, arguments);
}
/**
 * 数据源列表
 */
function _dataSourceDetail() {
  _dataSourceDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(data) {
    return _regenerator().w(function (_context7) {
      while (1) switch (_context7.n) {
        case 0:
          return _context7.a(2, request("/formManage/dataSourceDetail", METHOD.POST, data));
      }
    }, _callee7);
  }));
  return _dataSourceDetail.apply(this, arguments);
}
export function dataSourceList(_x0) {
  return _dataSourceList.apply(this, arguments);
}
/**
 * 查询数据集分页 
 */
function _dataSourceList() {
  _dataSourceList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(data) {
    return _regenerator().w(function (_context8) {
      while (1) switch (_context8.n) {
        case 0:
          return _context8.a(2, request("/formManage/dataSourceList", METHOD.POST, data));
      }
    }, _callee8);
  }));
  return _dataSourceList.apply(this, arguments);
}
export function queryDataSetPage(_x1) {
  return _queryDataSetPage.apply(this, arguments);
}
/**
 * 根据数据源和数据集编码查询元数据分页 
 */
function _queryDataSetPage() {
  _queryDataSetPage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(data) {
    return _regenerator().w(function (_context9) {
      while (1) switch (_context9.n) {
        case 0:
          return _context9.a(2, request("/formManage/queryDataSetPage", METHOD.POST, data));
      }
    }, _callee9);
  }));
  return _queryDataSetPage.apply(this, arguments);
}
export function getDataMetaBySetIdPage(_x10) {
  return _getDataMetaBySetIdPage.apply(this, arguments);
}
/**
 * 数据源同步
 */
function _getDataMetaBySetIdPage() {
  _getDataMetaBySetIdPage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(data) {
    return _regenerator().w(function (_context0) {
      while (1) switch (_context0.n) {
        case 0:
          return _context0.a(2, request("/formManage/getDataMetaBySetIdPage", METHOD.POST, data));
      }
    }, _callee0);
  }));
  return _getDataMetaBySetIdPage.apply(this, arguments);
}
export function dataSourceSync(_x11) {
  return _dataSourceSync.apply(this, arguments);
}
/**
 * 数据集同步
 */
function _dataSourceSync() {
  _dataSourceSync = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(data) {
    return _regenerator().w(function (_context1) {
      while (1) switch (_context1.n) {
        case 0:
          return _context1.a(2, request("/formManage/dataSourceSync", METHOD.POST, data));
      }
    }, _callee1);
  }));
  return _dataSourceSync.apply(this, arguments);
}
export function dataSetSync(_x12) {
  return _dataSetSync.apply(this, arguments);
}
/**
 * 数据集启用/停用
 */
function _dataSetSync() {
  _dataSetSync = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(data) {
    return _regenerator().w(function (_context10) {
      while (1) switch (_context10.n) {
        case 0:
          return _context10.a(2, request("/formManage/dataSetSync", METHOD.POST, data));
      }
    }, _callee10);
  }));
  return _dataSetSync.apply(this, arguments);
}
export function dataSetEnable(_x13) {
  return _dataSetEnable.apply(this, arguments);
}
/**
 * 数据集删除
 */
function _dataSetEnable() {
  _dataSetEnable = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(data) {
    return _regenerator().w(function (_context11) {
      while (1) switch (_context11.n) {
        case 0:
          return _context11.a(2, request("/formManage/dataSetEnable", METHOD.POST, data));
      }
    }, _callee11);
  }));
  return _dataSetEnable.apply(this, arguments);
}
export function dataSetDelete(_x14) {
  return _dataSetDelete.apply(this, arguments);
}
/**
 * 元数据删除
 */
function _dataSetDelete() {
  _dataSetDelete = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(data) {
    return _regenerator().w(function (_context12) {
      while (1) switch (_context12.n) {
        case 0:
          return _context12.a(2, request("/formManage/dataSetDelete", METHOD.POST, data));
      }
    }, _callee12);
  }));
  return _dataSetDelete.apply(this, arguments);
}
export function dataMetaDelete(_x15) {
  return _dataMetaDelete.apply(this, arguments);
}
/**
 * 数据集列表
 */
function _dataMetaDelete() {
  _dataMetaDelete = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(data) {
    return _regenerator().w(function (_context13) {
      while (1) switch (_context13.n) {
        case 0:
          return _context13.a(2, request("/formManage/dataMetaDelete", METHOD.POST, data));
      }
    }, _callee13);
  }));
  return _dataMetaDelete.apply(this, arguments);
}
export function dataSetList(_x16) {
  return _dataSetList.apply(this, arguments);
}
/**
 * 元数据列表
 */
function _dataSetList() {
  _dataSetList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(data) {
    return _regenerator().w(function (_context14) {
      while (1) switch (_context14.n) {
        case 0:
          return _context14.a(2, request("/formManage/dataSetList", METHOD.POST, data));
      }
    }, _callee14);
  }));
  return _dataSetList.apply(this, arguments);
}
export function dataMetaList(_x17) {
  return _dataMetaList.apply(this, arguments);
}
function _dataMetaList() {
  _dataMetaList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(data) {
    return _regenerator().w(function (_context15) {
      while (1) switch (_context15.n) {
        case 0:
          return _context15.a(2, request("/formManage/dataMetaList", METHOD.POST, data));
      }
    }, _callee15);
  }));
  return _dataMetaList.apply(this, arguments);
}